/// <amd-module name="typeahead/core/SearchParametersUpdater"/>

import {ProblemOrigin} from "typeahead/core/logging/ProblemOrigin";
import {Severity} from "typeahead/core/logging/Severity";
import TypeaheadErrorLogger from "typeahead/core/logging/TypeaheadErrorLogger";
import {IExtraSearchParam, Suggestion} from "typeahead/core/Suggestion";
import {Optional} from "typeahead/core/util/Optional";

const featureExtractorByElement: {[element: string]: string} = {
    airport_code_element: "getTla",
    category_element: "getCategory",
    city_element: "getCity",
    country_code_element: "getCountryIsoCode2",
    heds_element: "getIsHeds",
    hotel_id_element: "getHotelId",
    lat_long_element: "getLatLong",
    point_of_supply_element: "getPointOfSupply",
    region_id_element: "getRegionId",
    region_type_element: "getType",
    station_code_element: "getStationCode",
    ta_element: "getSuggestionData",
};

function updateElement(suggestion: Suggestion, elementId: string, valueGetter: string): void {
    const jqElement = $("#" + elementId);
    let newValue = "";
    if (jqElement.length > 0) {
        if (suggestion) {
            if (typeof suggestion[valueGetter] === "function") {
                const v: Optional<string> = suggestion[valueGetter]();
                if (v.isPresent()) {
                    newValue = v.get();
                }
            } else {
                TypeaheadErrorLogger.log(
                    new Error("" + valueGetter + " is not a method of Suggestion"),
                    Severity.MustFix, ProblemOrigin.UniversalTypeahead);
            }
        }

        if (newValue !== jqElement.val()) {
            jqElement.val(newValue);
            triggerDomElementChange(suggestion, jqElement);
        }
    }
}

function updateSearchNameElement(searchQuery: string, suggestion: Suggestion, elementId: string,
                                 typeaheadElementId: string) {
    const jqElement = $("#" + elementId);
    moveStoreableAttributes(elementId, typeaheadElementId);
    jqElement.val("");
    triggerDomElementChange(suggestion, jqElement);
}

function resetSearchNameElementOnOtherLobs(searchNameElementId: string) {
    const $searchName = $("input[id$=search_name][data-gcw-storeable-name=gcw-destination]");
    if ($searchName.length === 1 && searchNameElementId !== $searchName.attr("id")) {
        const $input = $searchName.parent().find("input[data-provide=utypeahead]");
        updateSearchNameElement(undefined, undefined, $searchName.attr("id"),
            $input.attr("id"));
    }
}

function triggerDomElementChange(suggestion: Suggestion, jqElement: JQuery) {
    if (!suggestion || suggestion.shouldTriggerDomElementChangeOnSelection()) {
        jqElement.trigger("change");
    }
}

function moveStoreableAttributes(sourceId: string, destinationId: string) {
    const $source = $("#" + sourceId);
    const $dest = $("#" + destinationId);

    if ($source.length && $dest.length && !$dest.attr("data-gcw-storeable-name")) {
        $dest.attr("name", $source.attr("name"));
        $dest.attr("data-gcw-storeable-name", $source.attr("data-gcw-storeable-name"));
        $dest.data("gcw-storeable-name", $source.data("gcw-storeable-name"));
        $dest.addClass("gcw-storeable");
        clearStoreableAttributes($source);
    }
}

function clearStoreableAttributes($el: JQuery) {
    $el.removeAttr("name");
    $el.removeAttr("data-gcw-storeable-name");
    $el.removeData("gcw-storeable-name");
    $el.removeClass("gcw-storeable");
}

function updateExtraSearchParams(suggestion: Suggestion, typeaheadElementId: string) {
    if (suggestion && suggestion.getExtraSearchParams().isPresent()) {
        populateExtraSearchParamElements(suggestion.getExtraSearchParams().get(), typeaheadElementId);
    } else {
        removeExtraSearchParamElements(typeaheadElementId);
    }
}

function populateExtraSearchParamElements(params: IExtraSearchParam[], typeaheadElementId: string): void {
    params.forEach((param) => {
        const $input = $("<input>", {type: "hidden", class: "uta-extra-search-param"});
        const nameAttr: string = param.field;
        $input.attr("name", param.field);
        $input.attr("value", param.value);
        const extraSearchElem = $("input[name*=" + nameAttr + "]");
        // Add the extra search element only if the element is not present already
        // Else change the value of the extra search param
        if (extraSearchElem.length !== 0) {
            $(extraSearchElem).attr("value", param.value);
            $(extraSearchElem).addClass("uta-extra-search-param");
        } else {
            $input.appendTo($("#" + typeaheadElementId).parents("form:visible"));
        }
    });
}

function removeExtraSearchParamElements(typeaheadElementId: string): void {
    // Include the logic to not remove an input element if it is a page element
    const extraSearchElems = $(".uta-extra-search-param");
    if (extraSearchElems.length > 0) {
        $(extraSearchElems).each( (index, elem) => {
            // Elements owned by the page have ID
            // uTA generated extra search elements do not have ID
            const isIdAttrPresent: boolean = $(elem).attr("id") ? true : false;
            if (isIdAttrPresent) {
                $(elem).attr("value", "");
                $(elem).removeClass("uta-extra-search-param");
            } else {
                $(elem).remove();
            }
        });
    }
}

export function updateForSuggestion(
    searchQuery: string,
    suggestion: Suggestion,
    elementIdByElementKey: {[elementKey: string]: string },
    typeaheadElementId: string): void {
    for (const element in featureExtractorByElement) {
        if (featureExtractorByElement.hasOwnProperty(element)) {
            updateElement(suggestion, elementIdByElementKey[element], featureExtractorByElement[element]);
        }
    }
    updateSearchNameElement(searchQuery, suggestion, elementIdByElementKey.search_name_element, typeaheadElementId);
    resetSearchNameElementOnOtherLobs(elementIdByElementKey.search_name_element);
    updateExtraSearchParams(suggestion, typeaheadElementId);
}
